import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  IonSlides,
  IonSlide
} from '@ionic/react'
import { getContentFeed } from '../../../services/api/contents'
import PlayableChapterSmallCard from '../../../components/common/PlayableChapterSmallCard'
import PlayableChapterSmallCardSkeleton from '../../../components/skeletons/PlayableChapterSmallCardSkeleton'
import './styles.scss'

const TopPlaylists = () => {
  const [contents, SetContents] = useState([])

  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400
  }

  useEffect(() => {
    const params = {
      limit: 12,
      category_id: [49]
    }
    getContentFeed(params).then((response) => {
      SetContents(response)
    }).catch(() => {
      SetContents([])
    })
  }, [])

  return (
    <section className='top-playlists'>
      {contents.length > 0 &&
        <IonSlides pager options={slideOpts}>
          {contents.map((chapter) => (
            <IonSlide key={chapter.id}>
              <PlayableChapterSmallCard chapter={chapter} />
            </IonSlide>
          ))}
        </IonSlides>}

      {contents.length === 0 &&
        <IonSlides options={slideOpts}>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
          <IonSlide>
            <PlayableChapterSmallCardSkeleton />
          </IonSlide>
        </IonSlides>}
      <Link
        className='like-title'
        to='/tops/explorar'
      >
        Ver más
      </Link>
    </section>
  )
}

export default TopPlaylists
